export default __webpack_public_path__ + "static/media/gallery_08.91b69b9f.jpg";